module.exports = __webpack_public_path__ + "static/media/calendar.1082d5d5.svg";